module.exports = __webpack_public_path__ + "img/31.1.ed0c74f1.jpg";